import { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PauseIcon from "@mui/icons-material/Pause";
import AudioButton from "../../../Components/Media/AudioButton";
import { Grid, Box, Typography } from "@mui/material";
import SmartCheckCard from "../../../Components/Card/AssetUI/SmartCheckCard";

const RecAsset = (props) => {
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  useEffect(() => {
    console.log("HERERE");
    if (props.userAns) {
      setCurrentIndexPlay(
        new Array(props.userAns?.ans?.length).fill(false)
      );
    }
  }, [props.userAns]);

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.userAns?.ans?.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.userAns?.ans?.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <>
      <Box sx={{ px: 3, color: "black" }}>
        {props.userAns &&
          props.userAns.ans.map((val, index) => {
            return (
              <Box>
                <span>Option {index + 1} : </span>
                <AudioButton
                  userAnswer={val}
                  playStatus={(status, end) => {
                    setPlayMode(status, index, end);
                  }}
                >
                  <IconButton
                    sx={{
                      color: "#DB8829",
                      backgroundColor: "#FFFFFF",
                      mx: 1,
                      padding: 0,
                     
                    }}
                  >
                    {currentIndexPlay[index] && (
                      <PauseIcon
                        sx={{
                          borderRadius: "50%",
                          padding: 1,
                          color: "#DB8829",
                          "@media (min-width: 1636px)": {
                            fontSize: "2.2rem",
                          },
                        }}
                      />
                    )}
                    {!currentIndexPlay[index] && (
                      <MusicNoteIcon
                        sx={{
                          borderRadius: "50%",
                          padding: 1,
                          "@media (min-width: 1636px)": {
                            fontSize: "2.2rem",
                          },
                        }}
                      />
                    )}
                  </IconButton>
                </AudioButton>
                {props.userAns.analysis &&
                  <SmartCheckCard unscripted={props?.asset?.unscripted_text ? props.asset.unscripted_text : false} smartCheckResult={props.userAns.analysis[index]} noanimation={true}></SmartCheckCard>
                }
              </Box>
            );
          })}
      </Box>

    </>
  );
};

export default RecAsset;